import React from 'react';
import ChipEdit from 'ChipEdit';
import transform from '../../../common/transform';
import PropTypes from 'prop-types';
import styles from './index.css';
import Header from './header/';
import Content from './content/';
import Footer from '@ifeng-fe/container_content/common/client/components/footer';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;

        const {
            docData,
            docData: { breadCrumbdata, relatedRecommend },
            slideData,
            recommendData,
            bookRecommendData,
            footer,
            asideAd1,
            infoAd,
            hardAd2,
            asideAd2,
            hardAd1,
            infoAd5,
            slidelastAd,
            bookRecommendAd,
            floatAd3,
            floatAd5,
            safeLevel,
            isCloseAlgRec,
            interact,
            hasCopyRight,
            sourceReason,
        } = content;
        const isHitBlack = safeLevel === 1;

        const contentData = {
            docData,
            slideData,
            recommendData,
            bookRecommendData,
            asideAd1,
            infoAd,
            hardAd2,
            asideAd2,
            hardAd1,
            infoAd5,
            slidelastAd,
            bookRecommendAd,
            floatAd3,
            floatAd5,
            isHitBlack,
            relatedRecommend,
            isCloseAlgRec,
            interact,
            hasCopyRight,
            sourceReason,
        };

        const headerData = {
            breadCrumbdata,
        };

        return (
            <div>
                <Header headerData={headerData} />
                <Content
                    content={contentData}
                    docData={docData}
                    slideData={slideData}
                    recommendData={recommendData}
                    bookRecommendData={bookRecommendData}
                />
                <div className={styles.footer}>
                    <Footer content={footer} />
                </div>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
